<template>
  <div class="container">
    <div class="privacy-content">
      <div class="header-banner"></div>
      <div class="avatar-section">
        <img src="@/assets/images/avatar.png" class="avatar">
        <span class="username">{{userInfo.username}}</span>
      </div>
      <div class="info-card">
        <div class="info-item-group">
          <div class="info-item">
            <span class="info-label">{{decryptLabel('s8faAtHNpBt+jsMfqWPF4A==')}}</span>
            <span class="info-value">{{userInfo.username}}</span>
          </div>
          <div class="divider-line"></div>
          <div class="info-item">
            <span class="info-label">{{decryptLabel('tHLRZE5boCh7jWPWAB2F0A==')}}</span>
            <span class="info-value">{{userInfo.id_num}}</span>
          </div>
          <div class="divider-line"></div>
          <div class="info-item">
            <span class="info-label">{{decryptLabel('taZknczfPRlIXe8nvp2tuA==')}}</span>
            <span class="info-value">{{userInfo.mobile}}</span>
          </div>
          <div class="divider-line"></div>
          <div class="info-item">
            <span class="info-label">{{decryptLabel('oyZEO2v/Jzvas0CvRDkPuQ==')}}</span>
            <span class="info-value">{{userInfo.cardType}}</span>
          </div>
          <div class="divider-line"></div>
          <div class="info-item">
            <span class="info-label">{{decryptLabel('Lnh9i2RCfPCcQSJ7ijigOA==')}}</span>
            <span class="info-value">{{userInfo.card_num}}</span>
          </div>
        </div>
      </div>

    </div>
    <button class="back-btn" @click="goBack">返回</button>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      userInfo: {
        username: "张三",
        id_num: "",
        mobile: "13800138111",
        card_num: "",
        repaymenttime: "",
        repaymenttime1: "",
        overdue_day: "",
        money: "",
        overdue_money: "",
        repayable_amount: ""
      }
    }
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    goBack() {
      this.$router.go(-1)
    },
    async loadUserInfo() {
      try {
        const userInfo = getStorage('userInfos')
        if (userInfo) {
          this.userInfo = userInfo
        } else {
          const storeUserInfo = this.$store.state.user.userInfo
          if (storeUserInfo) {
            this.userInfo = storeUserInfo
          }
        }
      } catch (error) {
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.privacy-content {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
}

.header-banner {
  height: 150px;
  background: linear-gradient(135deg, #1e80ff 0%, #0066ff 100%);
  border-radius: 0 0 20px 20px;
}

.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -75px;
  z-index: 2;
  position: relative;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
}

.username {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-top: 12px;
}

.info-card {
  background-color: #fff;
  border-radius: 12px;
  margin: 24px 0;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}

.info-item-group {
  padding: 0 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 18px 0;
}

.divider-line {
  height: 1px;
  background-color: #f2f4f6;
  margin: 0 8px;
}

.info-label {
  font-size: 16px;
  color: #666;
  flex-basis: 30%;
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: right;
  flex: 1;
}

.edit-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #ff9800;
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.back-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #ff9800;
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
</style>
